import {emptyWorkflowForm, emptyWorkflowProcess, emptyWorkflowProcessStage, emptyWorkflowTask, IWorkflowForm, IWorkflowProcess, IWorkflowProcessStage, IWorkflowTask} from "@retail-data-factory/rdf-angular-types-api";
import * as moment from "moment";

export function mapAuchanAuditProcessesFromService(item): IWorkflowProcess {
  return {
    ...emptyWorkflowProcess,
    userNameTaskAssigned: item['current_task_user'],
    dateArchive: item['date2arj'] ? moment(item['date2arj'], 'DD.MM.YYYY').toDate() : null,
    department: item['department'],
    isDelay: item['isdelay'] === "1",
    dateLastDecision: item['last_decis_date'] ? moment(item['last_decis_date'], 'DD.MM.YYYY').toDate() : null,
    lastDecision: item['last_decision'],
    manager: item['manager'],
    id: item['processId'],
    name: item['processName'],
    sector: item['sector'],
    dateStart: item['startTime'] ? moment(item['startTime'], 'DD.MM.YYYY').toDate() : null,
    supplier: item['supplier'],
    whoDelay: item['who_delay'],
    bonusApproved: item['bonus_approved'],
    bonusCalculated: item['bonus_calculated'],

    limit: item['Limit'],
    offset: item['Offset'],
    next: item['Next'] && item['Next'] === 'true'

  };
}

export function mapAuchanTaskFromService(item: object): IWorkflowTask {
  const process: IWorkflowProcess = {
    ...emptyWorkflowProcess,
    id: item['ProcessId'],
    name: item['ProcessName']
  };
  const stage: IWorkflowProcessStage = {
    ...emptyWorkflowProcessStage,
    id: '',
    name: item['StepName'],

  };
  const task: IWorkflowTask = {
    ...emptyWorkflowTask,
    id: item['TaskId'],
    name: item['TDisplayName'] ? item['TDisplayName'] : '',
    process: {
      ...emptyWorkflowProcess,
      id: item['ProcessId'],
      name: item['ProcessName']
    },
    stage: {
      ...emptyWorkflowProcessStage,
      id: '',
      name: item['StepName'],
    },

    userIdAssigned: item['UserID'],
    groupIdAssigned: item['GroupID'],
    userCodeAssigned: item['RecipientCode'],
    userNameAssigned: item['RecipientName'],
    qTitle: item['Qtitle'],
    dateStart: item['StartTime'] ? moment(item['StartTime'], 'DD.MM.YYYY HH:mm: ss.SSS').toDate() : null,
    dateCreate: item['CreateTime'] ? moment(item['CreateTime'], 'YYYY-MM-DD HH:mm: ss.SSS').toDate() : null,
    dateUpdate: item['UpdateTime'] ? moment(item['UpdateTime'], 'YYYY-MM-DD HH:mm: ss.SSS').toDate() : null,
    dateComplete: item['CompleteTime'] ? moment(item['CompleteTime'], 'DD.MM.YYYY HH:mm: ss.SSS').toDate() : null,

    instructions: item['Instructions'] ? item['Instructions'] : '',
    description: item['TaskDescription'] ? item['TaskDescription'] : '',

    isLocked: item['Locked'] === 1,
    assignType: item['assign_type'],

    assignShow: item['AShow'] ? item['AShow'] === '1' : false,

    actions: item['TRouteList'] ? item['TRouteList'].map(t => ({id: t, code: t, title: t, disabled: false})) : [],
    selectedAction: item['TSelectedRoute'] ? item['TSelectedRoute']  : '',
    forms: item['form_tabs'] ? item['form_tabs'].map(t => mapWorkflowTaskTab(t)) : [],
    processVariables: item['advProcessVariables'] ? item['advProcessVariables'] : {},
    taskVariables: item['taskVariables'] ? item['taskVariables'] : {}
  };
  task.taskVariables = item['profile'] ? item['profile'] : task.taskVariables;
  task.processVariables = item['process_profile'] ? item['process_profile'] : task.processVariables;
  return task;
}

export function mapWorkflowTaskTab(item: object): IWorkflowForm {

  console.log(item['profile']);

  const tab: IWorkflowForm = {
    ...emptyWorkflowForm,
    title: item['title'] ? item['title'] : '',
    tooltip: item['tooltip'] ? item['tooltip'] : '',
    formCode: item['form_code'] ? item['form_code'] : '',
    icon: item['icon'] ? item['icon'] : '',
    profile: item['profile'] ? item['profile'] : {},
    status: item['profile'] && item['profile']['status']?item['profile']['status']:'ACTIVE',
    supplier: item['profile'] && item['profile']['supplier']?item['profile']['supplier']:false
  };
  return tab;

}

export function mapAuchanTaskToService(task: IWorkflowTask): object {
  const result = {
    "GroupID": task.groupIdAssigned, //null,
    "UserID": task.userIdAssigned, //"2FC9E1C6-F632-102F-9203-000092F0E014",
    "RECIPIENTCODE": task.userCodeAssigned, //"buyer1_test",
    "RECIPIENTPNAME": task.userNameAssigned, //"Buyer1_test Buyer1_test",
    "ProcessId": task.process.id,//"35348",
    "ProcessName": task.process.name,//"Modification_react/Modification_proc",
    "TaskId": task.id,
    "Instructions": task.instructions, //"Дата создания задачи - 29.01.20 11:48<br>ID процесса-35348<br>E-mail поставщика - vika.khramtsova@auchan.ru<br>Поставщик-(3268) ДЖОНСОН & ДЖОНСОН ООО       	",
    "TDisplayName": task.name, //"Проверка данных постащика",
    "Qtitle": task.qTitle,
    "StartTime": "2020-01-29 11:48:53.0",
    "CreateTime": "2020-01-29 11:48:53.0",
    "UpdateTime": "2020-01-29 11:48:53.0",
    "StartTask": false,
    "Locked": task.isLocked ? 1 : 0,
    "StepName": task.stage.name,
    "TRouteList": task.actions //"Аннулировать заявку,Отправить  администратору,Отправить руководителю отдела,Отправить в архив"
  };
  return result;
}



